import React from 'react'
import { BrowserRouter as Link, NavLink, Router } from 'react-router-dom'
import '../App.css'

class Nav extends React.Component {

  render(){
    return (
      <div>
      <div className="nav-container">
        <nav className="desktop-nav">
          <NavLink className="nav-elem" to="/">HOME</NavLink>
          <NavLink className="nav-elem" to="/artists">ARTISTS</NavLink>
        </nav>
      </div>
      </div>
    )
  }
}

export default Nav;
